import { isDebugMode } from '@/utils/helper'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'
import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export default function ErrorPage() {
  const navigate = useNavigate()

  const isDebug = isDebugMode()

  return (
    <Container maxWidth='md'>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            p: { xs: 4, md: 6 },
            textAlign: 'center',
            borderRadius: 4,
            border: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <ErrorOutlineRoundedIcon
            color='error'
            sx={{
              fontSize: 96,
              mb: 2,
            }}
          />

          <Typography
            variant='h3'
            sx={{
              fontWeight: 700,
            }}
          >
            Something went wrong
          </Typography>

          <Typography
            color='text.secondary'
            sx={{
              mt: 2,
              maxWidth: 500,
              mx: 'auto',
            }}
          >
            An unexpected error occurred while loading this page. Try refreshing the page. If the
            problem persists, please try again later.
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent='center' mt={5}>
            <Button
              variant='contained'
              size='large'
              startIcon={<RefreshRoundedIcon />}
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </Button>

            <Button
              variant='outlined'
              size='large'
              startIcon={<HomeRoundedIcon />}
              onClick={() => navigate('/')}
            >
              Go Home
            </Button>
          </Stack>

          {isDebug && (
            <Paper
              variant='outlined'
              sx={{
                mt: 5,
                p: 2,
                textAlign: 'left',
                bgcolor: 'grey.50',
              }}
            >
              <Typography variant='subtitle2' fontWeight={600} gutterBottom>
                Development Mode
              </Typography>

              <Typography variant='body2' color='text.secondary'>
                Additional error information can be displayed here using
                <strong> useRouteError()</strong> or your application's error logging service.
              </Typography>
            </Paper>
          )}
        </Paper>
      </Box>
    </Container>
  )
}
